module.exports = __webpack_public_path__ + "img/placeholder-game-icon.4ef4e651.svg";